/* ═══ VOLVER ════════════════════════════════════════════════════════════════
   🔴 POR QUÉ NO ES UN «ATRÁS» A SECAS, QUE ES LO QUE PARECE QUE PIDE.

   Un botón que hace `history.back()` y ya, falla de dos maneras — las dos
   medidas en vivo el 23-ago-2026:

   (a) SACA DEL SITIO. Al aterrizar directo —desde WhatsApp, desde Instagram,
       desde un anuncio, que es por donde va a llegar media visita de esta
       tienda— `document.referrer` viene VACÍO. Ahí «atrás» te devuelve a
       Instagram. Un botón dentro de su sitio que expulsa de su sitio.

   (b) NO DICE A DÓNDE VA. Una flecha sola obliga a adivinar. Medido en ocho
       tiendas y periódicos grandes en celular: SIETE no llevan botón de atrás
       genérico. IKEA lleva 9 migas de pan y Apple 11 — resuelven lo mismo
       nombrando el destino. El único «Back» real (Airbnb) es de un asistente
       de varios pasos, no del sitio.

   🔴 Y POR QUÉ SÍ VALE LA PENA, QUE ES LA OTRA MITAD DE LA MEDICIÓN.
   Volver con el historial NO es lo mismo que un enlace al mismo sitio:

       bajar a la 4ª ficha de /tienda  →  entrar al producto  →  volver
         · con `history.back()`   → scrollY 2999  ← donde estaba
         · con `href="tienda.html"` → scrollY 0    ← arriba, a buscarla de nuevo

   Tres mil píxeles de diferencia. Eso es lo que se está comprando.

   ── CÓMO QUEDA ────────────────────────────────────────────────────────────
   El enlace nace en el marcado con su PADRE de verdad («Volver a la tienda» en
   una ficha, «Volver al inicio» en una interior). Sin JS, funciona: es un enlace
   normal a una página que existe.

   Si además resulta que se llegó desde otra página del propio sitio, este
   archivo lo mejora: le cambia el nombre al de la página de la que se viene y
   el clic pasa a `history.back()`, que es lo que restaura la posición.

   Nunca al revés: nunca `history.back()` sin saber a dónde lleva.             */

(() => {
  const enlace = document.querySelector('[data-volver]');
  if (!enlace) return;

  const LLAVE = 'iartb.previa';
  const rotulo = enlace.querySelector('[data-volver-tx]');

  /* ── el nombre de ESTA página ────────────────────────────────────────────
     No se escribe en ningún sitio: se lee de lo que la página ya dice de sí
     misma, por orden de precisión. Así una página nueva se nombra sola.
       1 · el último tramo de la miga de pan → «La Planner 2027»
       2 · el renglón del menú que está marcado como actual → «Shop»
       3 · el título del documento, hasta el separador
     Se recorta a 34: «Volver a Un espacio al que siempre puedes volver» es un
     botón que no cabe en ningún celular. */
  function nombreDeAqui(){
    /* 🔴 HIJO DIRECTO (`>`), y no un descendiente cualquiera. El propio botón de
       volver vive DENTRO del renglón de la miga y su rótulo también es un
       `<span>` — o sea que se leía a sí mismo y la ficha siguiente decía
       «Volver a Volver a la tienda». El nombre del producto es hijo directo del
       `<nav>`; el rótulo del botón cuelga de su `<a>`. */
    const miga = document.querySelector('.ficha-miga > span:not([aria-hidden])');
    if (miga && miga.textContent.trim()) return miga.textContent.trim().slice(0, 34);
    const actual = document.querySelector('.nav [aria-current="page"]');
    if (actual && actual.textContent.trim()) return actual.textContent.trim().slice(0, 34);
    return (document.title.split('·')[0] || '').trim().slice(0, 34);
  }

  /* Se apunta al salir y no al entrar: al entrar todavía no se sabe si alguien
     va a irse a otra página. `pagehide` y no `beforeunload` — `beforeunload`
     saca la página de la caché de ida y vuelta del navegador, que es
     precisamente la que hace que volver sea instantáneo. */
  addEventListener('pagehide', () => {
    try {
      sessionStorage.setItem(LLAVE, JSON.stringify({
        ruta: location.pathname, nombre: nombreDeAqui()
      }));
    } catch {}
  });

  /* Dos rutas son la misma página si solo se diferencian en `.html` o en el
     `index` final: el sitio se sirve de las tres formas. */
  const normal = r => r.replace(/\.html$/, '').replace(/\/index$/, '/').replace(/\/$/, '') || '/';

  function poner(){
    let previa = null;
    try { previa = JSON.parse(sessionStorage.getItem(LLAVE)); } catch {}

    /* Tres condiciones, y las tres tienen que cumplirse:
         · se llegó desde el propio sitio (si no, «atrás» sale a Instagram);
         · la nota de sessionStorage habla de ESA misma página (si no, es de
           una navegación vieja y nombraría mal el destino);
         · y no es esta misma página (recargar no es volver). */
    const ref = document.referrer;
    if (!ref || !previa || !previa.nombre) return;
    let r; try { r = new URL(ref); } catch { return }
    if (r.origin !== location.origin) return;
    if (normal(r.pathname) !== normal(previa.ruta)) return;
    if (normal(r.pathname) === normal(location.pathname)) return;

    rotulo.textContent = 'Volver a ' + previa.nombre;
    enlace.setAttribute('href', r.pathname + r.search);
    enlace.dataset.volverHist = '';
  }

  enlace.addEventListener('click', e => {
    if (!('volverHist' in enlace.dataset)) return;   /* enlace normal: que navegue */
    /* Ya hay una entrada anterior y es la que este botón nombra. `back()` es lo
       único que restaura la posición del scroll; navegar a la misma URL a mano
       aterriza arriba del todo. */
    e.preventDefault();
    history.back();
  });

  poner();
  /* Al volver, la página puede salir de la caché de ida y vuelta con el rótulo
     de la visita anterior. Se recalcula. */
  addEventListener('pageshow', ev => { if (ev.persisted) poner(); });
})();
